<template>
    <div class="competencies" v-if="sortedCompetencies && simulations && ratingOptions">
        <el-table class="table-responsive table-flush"
                header-row-class-name="thead-light"
                :data="sortedCompetencies">

            <el-table-column width="200">
                <div slot="header">
                    {{ $t('common.competency') }}
                </div>
                <template v-slot="{row}">
                    <h4 class="mb-0">
                        {{ competencyName(row) }}
                        <el-popover placement="top" v-if="competencyDescription(row)">
                            <i slot="reference" class="far fa-question-circle text-muted cursor-pointer ml-1"></i>
                            <div class="pt-2 pr-2 pl-2">
                                <h4>{{ competencyName(row) }}</h4>
                                <p class="description mb-0">{{ competencyDescription(row) }}</p>
                            </div>
                        </el-popover>
                    </h4>
                    <div v-if="row.domain">
                        <badge rounded :type="row.domain.color" class="mt-1">
                            {{ competencyDomainName(row) }}
                        </badge>
                    </div>
                </template>
            </el-table-column>

            <el-table-column class-name="comment">
                <div slot="header">
                    {{ $t('competencies.rating') }} / {{ $t('dashboard.comment') }}
                </div>
                <template v-slot="{row}">

                    <rating v-if="current.state.published && current.state.competencies && current.state.competencies[simulationRole]"
                        :value="current.state.competencies[simulationRole][row.id]"
                        :options="ratingOptions"
                        :disabled="true"
                    >
                    </rating>
                    
                    <!-- Keep it on the same line -->
                    <p class="description comment mb-0 pl-5">{{ competencyComment(current.state, simulationRole, row.id) }}</p>
                </template>
            </el-table-column>

        </el-table>
    </div>
</template>

<script>
    import Rating from './Rating'

    export default {

        components: {
            Rating
        },

        props: {

            num: {
                type: Number,
            },

            simulations: {
                type: Array,
            },

            competencies: {
                type: Object,
            },

            position1Competencies: {
                type: Object,
            },

            position2Competencies: {
                type: Object,
            },

            registration: {
                type: Object,
            },

            ratingOptions: {
                type: Array,
            },
        },

        computed: {

            simulationRole() {
                return this.registration.degree['simulation_role_' + this.num]
            },

            sortedCompetencies() {
                return Object.values(this['position' + this.num + 'Competencies']).map(competency => this.competencies[competency.id])
                    .sort((a, b) => a.position - b.position)
            },

            currentIndex() {
                return this.simulations.findIndex(simulation => simulation.id == this.$route.params.simulationId)
            },

            current() {
                return this.simulations[this.currentIndex]
            },
        },

        methods: {
            
            competencyName(competency) {
                const nameProp = 'name_' + this.registration.degree.lang
                return competency[nameProp]
            },

            competencyDescription(competency) {
                const posCompetency = this['position' + this.num + 'Competencies'][competency.id]
                if (!posCompetency) {
                    return ''
                }
                return posCompetency.pivot.description
            },

            competencyComment(state, simulationRole, id) {
                return state.competency_comments && state.competency_comments[simulationRole]
                    ? state.competency_comments[simulationRole][id]
                    : null
            },

            competencyDomainName(competency) {
                const nameProp = 'name_' + this.registration.degree.lang
                return competency.domain[nameProp]
            },
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .competencies >>> .el-table th.session .cell {
        justify-content: center;
        line-height: 1rem;
        padding: 0.7rem 0;
    }
    .competencies >>> .el-table th.session .cell a:hover {
        color: #233dd2;
    }
    .competencies >>> .el-table .description,
    .competencies >>> .el-table .comment {
        padding-left: 0;
    }
    .competencies >>> .el-table .rating {
        float: left;
    }
    .competencies >>> .el-table .rating button {
        width: 30px;
        height: 30px;
    }

</style>
